const ADD_PARTY_DISCOUNT = "ADD_PARTY_DISCOUNT";
const UPDATE_PARTY_DISCOUNT = "UPDATE_PARTY_DISCOUNT";
const DELETE_PARTY_DISCOUNT = "DELETE_PARTY_DISCOUNT";
const PARTY_DISCOUNTS = "PARTY_DISCOUNTS";
const ADD_PARTY_DISCOUNT_ERROR = "ADD_PARTY_DISCOUNT_ERROR";
const PARTY_DISCOUNT_DETAILS = "PARTY_DISCOUNT_DETAILS";


export {
	ADD_PARTY_DISCOUNT,
	UPDATE_PARTY_DISCOUNT,
	DELETE_PARTY_DISCOUNT,
	PARTY_DISCOUNTS,
	ADD_PARTY_DISCOUNT_ERROR,
	PARTY_DISCOUNT_DETAILS,
};
